module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_7005.b27b87b5.png";